 <template>
  <div>
    <b-modal
      id="addPerson"
      v-model="this.showPersonEdit"
      title="Add/Edit Person Involved"
      @show="resetForm"
      scrollable
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <div>
        <ValidationObserver v-slot="{ invalid }" ref="formValidationObserver">
            <b-form @submit.prevent="doSaveInvolvedPerson">
              <b-form-group class="w-75">
                <label class="control-label">Person Type</label>
                <b-form-select v-model="eventPersonForEdit.type" class="mb-3">
                  <b-form-select-option :value=1>Involved Person</b-form-select-option>
                  <b-form-select-option :value=2>Witness</b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group>
                <label class="control-label">First Name</label>
                <ValidationProvider name="First Name" rules="required" v-slot="validation">
                  <b-input
                  id="firstName"
                    class="form-control"
                    placeholder="First Name"
                    :state="spr2_getValidationState(validation)"
                    v-model="eventPersonForEdit.firstName"
                    aria-describedby="first-name-feedback"
                  />
                  <b-form-invalid-feedback id="first-name-feedback">
                    {{ validation.errors[0] }}
                  </b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group>
                <label class="control-label">Last Name</label>
                <ValidationProvider name="Last Name" rules="required" v-slot="validation">
                <b-form-input
                  id="lastName"
                  class="form-control"
                  placeholder="Last Name"
                  v-model="eventPersonForEdit.lastName"
                  :state="spr2_getValidationState(validation)"
                  aria-describedby="last-name-feedback"
                />
                 <b-form-invalid-feedback id="last-name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
              </b-form-group>
              <b-form-group>
                <label class="control-label">Address</label>
                <div class="row no-gutters">
                  <div class="col-12">
                    <b-input class="form-control" placeholder="Street Address" v-model="eventPersonForEdit.address.streetAddress1" />
                  </div>
                  <div class="col-md-6 col-8 mt-1 pr-1">
                    <b-input class="form-control" placeholder="City" v-model="eventPersonForEdit.address.city" />
                  </div>
                  <div class="col-md-3 col-4 mt-1 pr-1">
                    <b-form-input placeholder="State" v-model="eventPersonForEdit.address.state" />
                  </div>
                  <div class="col-md-3 col-6 mt-1">
                    <b-input class="form-control" placeholder="Postal Code"  v-model="eventPersonForEdit.address.postalCode"/>
                  </div>
                </div>
              </b-form-group>
              <b-form-group class="w-50">
                <label class="control-label">Primary Phone</label>
                  <ValidationProvider name="Phone Number" rules="phoneNumber" v-slot="validation">
                    <b-form-input class="form-control" v-model="eventPersonForEdit.phoneNumber" placeholder="888-888-888"
                     name="Phone Number"
                     :state="spr2_getValidationState(validation)"
                    aria-describedby="phone-number-feedback" />
                    <b-form-invalid-feedback id="phone-number-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group>
                <label class="control-label">Affiliation</label>
                  <b-form-select v-model="eventPersonForEdit.affiliation" class="mb-3">
                    <b-form-select-option :value=0>Other</b-form-select-option>
                    <b-form-select-option :value=1>Resident</b-form-select-option>
                    <b-form-select-option :value=2>Visitor</b-form-select-option>
                    <b-form-select-option :value=3>Bystander</b-form-select-option>
                    <b-form-select-option :value=4>Employee</b-form-select-option>
                </b-form-select>
                <b-input v-if="eventPersonForEdit.affiliation === 0" class="form-control" placeholder="Other Affiliation Description"  v-model="eventPersonForEdit.otherAffiliationDescription"/>
              </b-form-group>
              <!--Display for involved person-->
              <b-form-group>
                <label class="control-label">Nature of Involvement</label>
                <b-input class="form-control" placeholder="Enter details" v-model="eventPersonForEdit.natureOfInvolvement" />
              </b-form-group>
              <b-button variant="light" @click="closePersonEditor">Close</b-button>
            <b-button type ="submit" variant="primary" :disabled="invalid">Save</b-button>
          </b-form>
        </ValidationObserver>
      </div>
    </b-modal>

    <div class="row mt-3">
      <div class="col-12 d-flex justify-content-end">
        <b-btn class="btn btn-success" @click="showNewPersonForm()">
          <i class="fas fa-plus"></i> Add Person
        </b-btn>
      </div>
    </div>
    <div class="row" v-if="involvedPeopleByType.length > 0">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <h5>Person Involved</h5>
      </div>
      <div class="col-12 pt-1">
        <b-list-group>
          <b-list-group-item v-for="involvedPerson in involvedPeopleByType" v-bind:key="involvedPerson.id">
            <div class="row">
              <div class="col-md-6 col-12">
                <p class="m-0">{{involvedPerson.firstName}} {{involvedPerson.lastName}}</p>
                <small class="text-black-50">{{ involvedPerson.address.streetAddress1 }}, {{ involvedPerson.address.city }} {{ involvedPerson.address.state }} {{ involvedPerson.address.postalCode }}</small>
              </div>
              <div class="col-md-4 col-10">
                <small class="d-block">
                  <i class="fas fa-phone-square text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.phoneNumber }}</span>
                </small>
                <small class="d-block">
                  <i class="fas fa-map-marker text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.affiliation }}</span>
                </small>
                <small class="d-block">
                  <i class="fas fa-info-circle text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.natureOfInvolvement }}</span>
                </small>
              </div>
              <div class="col-md-2 col-2 text-right">
                <b-btn variant="link" @click="showEditPersonForm(involvedPerson.id)">
                  <i class="fas fa-pencil"></i>
                </b-btn>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <div class="row mt-5" v-if="witnessesByType.length > 0">
      <div class="col-12 d-flex align-items-center justify-content-between" >
        <h5>Witnesses</h5>
      </div>
      <div class="col-12 pt-1">
        <b-list-group>
          <b-list-group-item v-for="involvedPerson in witnessesByType" v-bind:key="involvedPerson.id">
            <div class="row">
              <div class="col-md-6 col-12">
                <p class="m-0">{{involvedPerson.firstName}} {{involvedPerson.lastName}}</p>
                <small class="text-black-50">{{ involvedPerson.address.streetAddress1 }}, {{ involvedPerson.address.city }} {{ involvedPerson.address.state }} {{ involvedPerson.address.postalCode }}</small>
              </div>
              <div class="col-md-4 col-10">
                <small class="d-block">
                  <i class="fas fa-phone-square text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.phoneNumber }}</span>
                </small>
                <small class="d-block">
                  <i class="fas fa-map-marker text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.affiliation }}</span>
                </small>
                <small class="d-block">
                  <i class="fas fa-info-circle text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.natureOfInvolvement }}</span>
                </small>
              </div>
              <div class="col-md-2 col-2 text-right">
                <b-btn variant="link" @click="showEditPersonForm(involvedPerson.id)">
                  <i class="fas fa-pencil"></i>
                </b-btn>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../../mixins/Spr2SharedFunctions'
export default {
  mixins: [spr2Validation],
  name: 'EventPeople',
  data () {
    return {
      eventPersonForEdit: {address: {}},
      showPersonEdit: false,
      involvedPeople: []
    }
  },
  computed: {
    involvedPeopleByType () {
      return this.involvedPeople.filter(p => p.type === 'Involved')
    },
    witnessesByType () {
      return this.involvedPeople.filter(p => p.type === 'Witness')
    }
  },
  props: {
    eventId: null
  },
  created () {
    this.doLoadInvolvedPeople()
  },
  methods: {
    ...mapActions('events', ['getInvolvedPerson', 'saveInvolvedPerson', 'getInvolvedPeople']),
    resetForm () {
      console.log('resetForm called')
    },
    async doSaveInvolvedPerson () {
      await this.saveInvolvedPerson({ eventId: this.eventId, involvedPerson: this.eventPersonForEdit })
      await this.doLoadInvolvedPeople()
      this.$toasted.show('Involved Person Saved.', { duration: 3000 })
      this.showPersonEdit = false
    },
    async doLoadInvolvedPeople () {
      var response = await this.getInvolvedPeople(this.eventId)
      this.involvedPeople = response.data.involvedPeople
    },
    initializePersonForEdit () {
      this.eventPersonForEdit = { type: 1, firstName: '', lastName: '', address: {} }
    },
    showNewPersonForm () {
      this.initializePersonForEdit()
      this.showPersonEdit = true
    },
    async showEditPersonForm (personId) {
      var response = await this.getInvolvedPerson({ eventId: this.eventId, personId: personId })
      this.eventPersonForEdit = response.data.involvedPerson
      this.showPersonEdit = true
    },
    closePersonEditor () {
      this.showPersonEdit = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/event/EventPeople.vue